export default __webpack_public_path__ + "static/media/search_lens.7f51b492.svg";